<template>
  <div ref="bienvenidaRef" class="bienvenida-section">
    <div class="franja-superior">
      <img
        ref="ornamentoArriba"
        src="@/assets/apreciable1.png"
        alt="ornamento"
        class="ornamento-arriba"
      />
    </div>

    <!-- ENCABEZADO -->
    <div ref="encabezadoRef" class="encabezado-container">
      <p class="encabezado-fecha">11.07.2025 – CD. VICTORIA, TAMAULIPAS</p><br>
      <h2 class="encabezado-nombres">
        <span class="nombre-principal">ALEJANDRA MARÍA</span><br>
        <span class="apellidos-novios">Villarreal Zapata</span><br>
        <div class="separador-central">
          <img src="@/assets/and.png" alt="separador" class="imagen-separador" />
        </div>
        <span class="nombre-principal"> ADOLFO IVAN</span><br>
        <span class="apellidos-novios">Rodríguez Bugarín</span>
      </h2>
    </div>

    <div class="bienvenida-container">
      <p ref="textoPrincipalRef" class="bienvenida-text">{{ mensaje }}</p>
      <p ref="nosCasamosRef" class="textmia">{{ mensajeFinal }}</p>

      <!-- SECCIÓN PADRES -->
      <div ref="padresContainerRef" class="padres-container">
        <h3 class="padres-titulo" ref="padresTituloRef">NUESTROS<br />PADRES</h3>
        <p
          class="padres-nombre"
          v-for="(padre, index) in listaPadres"
          :key="index"
          :ref="el => padresRefs[index] = el"
        >
          <template v-if="padre.includes('Cesar Villarreal Nieto')">
            Cesar Villarreal Nieto <i class="fas fa-cross small-cross"></i>
          </template>
          <template v-else>
            {{ padre }}
          </template>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, nextTick } from 'vue'
import { gsap } from 'gsap'

export default {
  name: 'BienvenidaPage',
  setup() {
    const bienvenidaRef = ref(null)
    const ornamentoArriba = ref(null)
    const encabezadoRef = ref(null)
    const textoPrincipalRef = ref(null)
    const nosCasamosRef = ref(null)
    const padresTituloRef = ref(null)
    const padresContainerRef = ref(null)
    const padresRefs = ref([])

    const mensaje = ref('')
    const mensajeFinal = ref('')

    const listaPadres = [
      'Cesar Villarreal Nieto',
      'Ma. de Lourdes Zapata Pérez',
      '&',
      'Adolfo Rodríguez Resendez',
      'Alicia Bugarín Castro'
    ]

    const text = 'Serviremos a Dios juntos y donde él nos lleve, iremos. Ese es nuestro anhelo y esa es nuestra promesa.'
    const textFinal = '¡Nos Casamos!'

    onMounted(async () => {
      await nextTick()

      // Ocultar todos los elementos
      gsap.set([
        ornamentoArriba.value,
        encabezadoRef.value,
        textoPrincipalRef.value,
        nosCasamosRef.value,
        padresTituloRef.value,
        ...padresRefs.value
      ], { opacity: 0, y: 40 })

      // Animaciones al entrar en viewport
      const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const tl = gsap.timeline({ defaults: { duration: 1, ease: 'power2.out' } })

            tl.to(ornamentoArriba.value, { y: 0, opacity: 1 })
              .to(encabezadoRef.value, { y: 0, opacity: 1 }, "-=0.7")
              .add(() => mensaje.value = text)
              .to(textoPrincipalRef.value, { y: 0, opacity: 1 }, "-=0.6")
              .add(() => mensajeFinal.value = textFinal)
              .to(nosCasamosRef.value, { y: 0, opacity: 1 }, "-=0.5")
              .to(padresTituloRef.value, { y: 0, opacity: 1 }, "-=0.4")
              .to(padresRefs.value, {
                y: 0,
                opacity: 1,
                stagger: 0.25
              }, "-=0.2")

            observer.unobserve(entry.target)
          }
        })
      }, { threshold: 0.3 })

      if (bienvenidaRef.value) observer.observe(bienvenidaRef.value)
    })

    return {
      bienvenidaRef,
      ornamentoArriba,
      encabezadoRef,
      textoPrincipalRef,
      nosCasamosRef,
      padresTituloRef,
      padresContainerRef,
      padresRefs,
      mensaje,
      mensajeFinal,
      listaPadres
    }
  }
}
</script>



<style scoped>
.small-cross {
  font-size: 0.8em;
  color: #a17e4e; /* Dorado sutil */
  margin-left: 4px;
}
.bienvenida-section {
  padding: 30px 0;
}

.franja-superior {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  padding-left: 0;
  overflow: hidden;
}

.ornamento-arriba {
  width: 260px;
  transform: translateX(-80px);
}

.encabezado-container {
  text-align: center;
  margin-top: 30px;
  margin-bottom: 20px;
  opacity: 0;
  transform: translateY(50px);
}

.encabezado-fecha {
  font-family: 'Karla', sans-serif;
  font-size: 14px;
  color: #555;
  letter-spacing: 1px;
  text-transform: uppercase;
  margin-bottom: 10px;
}

.encabezado-nombres {
  font-family: 'Playfair Display', serif;
  font-size: 32px;
  font-weight: bold;
  color: #1e1e1e;
  line-height: 1.2;
}

.nombre-principal {
  font-family: 'nombres';
  font-weight: 400;
}

.nombre-secundario {
  font-style: italic;
  margin-left: 5px;
}

.bienvenida-container {
  text-align: center;
  padding: 30px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.bienvenida-text {
  font-size: 18px;
  font-family: 'padres';
  color: #333;
  margin: 20px;
  transform: translateY(20px);
  opacity: 0;
}

.textmia {
  font-family: "say2";
  font-size: 26px;
  color: #302f2d;
  margin-top: 20px;
  opacity: 0;
}

/* NUEVO: Sección Padres */
.padres-container {
  margin-top: 40px;
  text-align: center;
}
.separador-central {
  text-align: center;
  margin: 10px 0;
}

.imagen-separador {
  width: 150px;
  height: auto;
  margin-top:10px;
    margin-bottom:10px;

  filter: brightness(0.4) contrast(1.2);
  opacity: 0.8;
}

.padres-titulo {
  font-family: 'Playfair Display', serif;
  font-size: 22px;
  font-weight: 500;
  color: #1e1e1e;
  line-height: 1.5;
  margin-bottom: 20px;
  letter-spacing: 1px;
}
.apellidos-novios {
  font-size: 30px; /* Tamaño un poco más pequeño */
  font-family: "Hearth Stone", sans-serif;
  font-weight: 400;
  line-height: 1.5; /* Ajusta la separación entre líneas */

  color: #cfcfcf; /* Color gris claro */
}
.padres-nombre {
  font-family: 'padres', serif;
  font-size: 16px;
  color: #444;
  margin-bottom: 8px;
  opacity: 0;
}
</style>
